import { NotificationTypes } from "~enums/notificationTypes";
import type { Notification } from "~types/notification";
import DefaultPopoverNotificationItem from "./DefaultPopoverNotificationItem";
import ExportPopoverNotificationItem from "./ExportPopoverNotificationItem";
import ImportPopoverNotificationItem from "./ImportPopoverNotificationItem";
import ReportPopoverNotificationItem from "./ReportPopoverNotificationItem";

type Props = {
  notification: Notification;
  onClick: (notification: Notification) => void;
};

const PopoverNotificationItem = ({ notification, onClick }: Props) => {
  switch (notification.type) {
    case NotificationTypes.Export:
      return <ExportPopoverNotificationItem notification={notification} onClick={onClick} />;
    case NotificationTypes.Report:
      return <ReportPopoverNotificationItem notification={notification} onClick={onClick} />;
    case NotificationTypes.Import:
      return <ImportPopoverNotificationItem notification={notification} onClick={onClick} />;
    default:
      return <DefaultPopoverNotificationItem notification={notification} onClick={onClick} />;
  }
};

export default PopoverNotificationItem;
